import angular from 'angular';
import uiRouter from 'angular-ui-router';
import DashboardComponent from './dashboard.component';

import Main from './main/main';
import Movements from './movements/movements';
import Pos from './pos/pos';

const dashboardModule = angular.module('tinaba.components.dashboard', [
  uiRouter,
  Main.name,
  Movements.name,
  Pos.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('dashboard', {
      url: '/dashboard',
      template: '<dashboard></dashboard>',
      redirect: 'dashboard.main'
    });
})

.component('dashboard', DashboardComponent);

export default dashboardModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/dashboard.js
 **/